module.exports = __webpack_public_path__ + "img/award_no_picture.e450aa9b.png";